import { useId, type ReactNode } from 'react'
import { Box, Chip, Stack, Typography } from '@mui/material'

export default function MapLayerOption({
  label,
  tags = [],
  description,
  control,
  children,
}: {
  label: string
  tags?: string[]
  description?: string
  control: (labelId: string) => ReactNode
  children?: ReactNode
}) {
  const labelId = useId()
  return (
    <Box
      role="group"
      aria-labelledby={labelId}
      sx={{
        p: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: 'background.paper',
        '& .MuiSwitch-root': { flexShrink: 0 },
        '& .MuiSwitch-switchBase:not(.Mui-checked)': { color: 'text.secondary' },
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1} sx={{ minHeight: 32 }}>
        <Stack direction="row" alignItems="center" gap={0.75} flexWrap="wrap" sx={{ minWidth: 0 }}>
          <Typography id={labelId} variant="body2" fontWeight={700}>
            {label}
          </Typography>
          {tags.map(tag => (
            <Chip key={tag} label={tag} size="small" variant="outlined" sx={{ height: 21, fontSize: 11 }} />
          ))}
        </Stack>
        {control(labelId)}
      </Stack>
      {description && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5, lineHeight: 1.5 }}>
          {description}
        </Typography>
      )}
      {children}
    </Box>
  )
}
